import React from "react";
import { Card, Space, Spin, Avatar } from "antd";
import { UserOutlined, RobotOutlined } from "@ant-design/icons";

interface ChatMessage {
    id: string;
    role: "user" | "assistant";
    content: string;
    timestamp: Date;
}

interface ChatMessageProps {
    message: ChatMessage;
}

interface LoadingMessageProps {
    loadingText?: string;
}

export const ChatMessageComponent: React.FC<ChatMessageProps> = ({ message }) => {
    const isUser = message.role === "user";
    const isError = message.content.startsWith("Error:");

    return (
        <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4 `}>
            <div
                className={`flex ${
                    isUser ? "flex-row-reverse" : "flex-row"
                } items-start space-x-2 max-w-xs lg:max-w-md`}
            >
                {/* Avatar */}
                <Avatar
                    size="small"
                    icon={isUser ? <UserOutlined /> : <RobotOutlined />}
                    className={`${isUser ? "ml-2" : "mr-2"} flex-shrink-0 ${isUser ? "bg-blue-600" : "bg-gray-500"}`}
                />

                {/* Message Bubble */}
                <div
                    className={`px-4 py-3 rounded-lg shadow-sm ${
                        isUser
                            ? "bg-blue-600 text-white rounded-tr-sm"
                            : isError
                            ? "bg-red-50 text-red-800 border border-red-200 rounded-tl-sm"
                            : "bg-gray-50 text-gray-900 border border-gray-200 rounded-tl-sm"
                    }`}
                >
                    {/* Message Content */}
                    <div className="text-sm whitespace-pre-wrap break-words leading-relaxed">{message.content}</div>

                    {/* Timestamp */}
                    <div
                        className={`text-xs mt-2 ${
                            isUser ? "text-blue-100" : isError ? "text-red-500" : "text-gray-500"
                        }`}
                    >
                        {message.timestamp.toLocaleTimeString()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const LoadingMessage: React.FC<LoadingMessageProps> = ({ loadingText = "Gemini Nano is thinking..." }) => {
    return (
        <div className="flex justify-start mb-4">
            <div className="flex flex-row items-start space-x-2 max-w-xs lg:max-w-md">
                {/* Avatar */}
                <Avatar size="small" icon={<RobotOutlined />} className="mr-2 flex-shrink-0 bg-gray-500" />

                {/* Loading Bubble */}
                <Card size="small" className="shadow-sm rounded-tl-sm">
                    <Space>
                        <Spin size="small" />
                        <span className="text-sm text-gray-600">{loadingText}</span>
                    </Space>
                </Card>
            </div>
        </div>
    );
};
